const fontSizes = {
    xs: '2rem', // Adjust this value for mobile size
    sm: '3rem', // Adjust this value for small screens
    md: '4rem', // Adjust this value for medium screens
    lg: '4.5rem', // Adjust this value for large screens
  };
  
  export default fontSizes;